// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a654ab08","455":"711f2261","644":"fad1cec3"}[chunkId] + ".chunk.js";
};